import { HubConnection } from "@microsoft/signalr";

import { apiClient } from "@/core/api/ApiClient";
import {
  InAppNotificationReceivedDto,
  NotificationHubClientMethodName,
  NotificationHubServerMethodName,
} from "@/core/api/generated/v1";

// import { inAppNotificationReceived } from "@/store/notifications/slice";
import { notificationService } from "../services/notification";
import { BaseHubService } from "./baseHubService";

/** Client methods that can be called by the server. */
const clientMethods = NotificationHubClientMethodName;

/** Server methods that can be called by the client. */
const serverMethods = NotificationHubServerMethodName;

export class NotificationHubService extends BaseHubService {
  constructor() {
    super({
      hubName: "NotificationHub",
      showLogs: true,
      logIncomingMessages: true,
      logOutcomingMessages: true,
    });

    this.on("initialized", ({ connection }) => {
      this.registerMethodHandlers(connection);
    });

    this.on("connected", ({ connectionId }) => {
      apiClient.updateSignalConnectionIds({
        notificationHubConnectionId: connectionId,
      });

      // this.echo("Hello");
    });
  }

  public async connect(): Promise<void> {
    await super.connectToHub("/signalr/notificationhub");
  }

  public async disconnect(): Promise<void> {
    await super.disconnectFromHub();
  }

  private registerMethodHandlers(connection: HubConnection) {
    this.registerMethodHandler(clientMethods.TestNotify, this.onTestNotify.bind(this));
    this.registerMethodHandler(clientMethods.Echo, this.onEcho.bind(this));
    this.registerMethodHandler(
      clientMethods.ServerErrorOccurred,
      this.onServerErrorOccurred.bind(this),
    );

    this.registerMethodHandler(
      clientMethods.InAppNotificationReceived,
      this.onInAppNotificationReceived.bind(this),
    );
  }

  //#region Method handlers

  private onTestNotify(data: any) {}

  private onEcho(data: any) {}

  private onServerErrorOccurred(data: any) {
    // always log error response from the BE
    console.error(this.logPrefix, "BE notified about server error:", data);
  }

  private onInAppNotificationReceived(data: InAppNotificationReceivedDto) {
    notificationService.handleNewInAppNotification(data);
  }

  //#endregion

  //#region Server methods

  public echo(message: string) {
    this.send(serverMethods.Echo, message);
  }

  //#endregion
}

export const notificationHubService = new NotificationHubService();
